import { Controller } from "stimulus";

export default class extends Controller {

  switcher(event) {
    let container = event.currentTarget;
    let input = document.getElementById("switcher-input");
    let button = document.getElementById("switcher-btn");

    if (input.checked) {
      button.style.marginLeft = "20px";
      button.style.backgroundColor = "#FFF";
      container.style.backgroundColor = "#1D1D1D";
    } else {
      button.style.marginLeft = "2px";
      button.style.backgroundColor = "#1D1D1D";
      container.style.backgroundColor = "#FFF";
    }
  }
}